<div
  #bubble
  class="offline-bubble"
  *ngIf="!online"
  [class.is-expanded]="expanded"
  [style.left.px]="posX"
  [style.top.px]="posY"
  (pointerdown)="onPointerDown($event)"
  role="status"
  aria-live="polite"
>
  <div class="offline-bubble__icon">
    <svg
      class="offline-bubble__wifi"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      aria-hidden="true"
    >
      <path
        d="M318.586 363.5L256 424l-62.586-60.5S212 336 256 336s62.586 27.5 62.586 27.5zM407.31 278L372 312s-41-46-116-46-116 46-116 46l-35.31-34S142.5 214 256 214s151.31 64 151.31 64z"
        fill="none"
        stroke="currentColor"
        stroke-width="32"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M496 192l-36.69 35.5S386.5 141 256 141 52.69 227.5 52.69 227.5L16 192S88 88 256 88s240 104 240 104z"
        fill="none"
        stroke="currentColor"
        stroke-width="32"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <span class="offline-bubble__slash" aria-hidden="true"></span>
  </div>
  <span class="offline-bubble__label">
    Você está offline. Mostrando a última versão salva.
  </span>
</div>
